import React, { useState } from "react";
import { ClickAwayListener } from "@mui/material";
import styled from "styled-components";

const LOGIN_OPTIONS = [
  { label: "Ekalsutra School ERP", url: process.env.REACT_APP_SCHOOL_LOGIN },
  { label: "Ekalsutra ERP v2", url: process.env.REACT_APP_ERP_LOGIN },
  { label: "Ekalsutra Advance", url: process.env.REACT_APP_ERP_ADVANCE_LOGIN },
];

// Opens on hover or click. `renderTrigger` receives the props to spread on the
// element that opens the menu, so each caller keeps its own button styling.
function LoginDropdown({ className, renderTrigger }) {
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);

  return (
    <ClickAwayListener onClickAway={close}>
      <Container
        className={className}
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={close}
        onKeyDown={(e) => e.key === "Escape" && close()}
      >
        {renderTrigger({
          type: "button",
          "aria-expanded": open,
          onClick: () => setOpen(true),
        })}
        {open && (
          <Menu>
            {LOGIN_OPTIONS.map(({ label, url }) => (
              <a
                key={label}
                href={url}
                target="_blank"
                rel="noreferrer noopener"
                onClick={close}
              >
                {label}
              </a>
            ))}
          </Menu>
        )}
      </Container>
    </ClickAwayListener>
  );
}

export default LoginDropdown;

const Container = styled.div`
  position: relative;
  display: inline-block;
`;
const Menu = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  z-index: 10;
  display: flex;
  flex-direction: column;
  padding: 6px;
  background-color: #fff;
  border-radius: 0.8rem;
  box-shadow: 0 8px 25px 0 rgba(49, 67, 109, 0.18);

  /* Keeps the menu open while the pointer crosses the gap below the trigger */
  &::before {
    content: "";
    position: absolute;
    top: -8px;
    left: 0;
    right: 0;
    height: 8px;
  }

  /* Doubled selector outranks the header's global "a" styles */
  && a {
    padding: 10px 14px;
    font-size: 1rem;
    font-weight: 500;
    color: #31436d;
    text-decoration: none;
    white-space: nowrap;
    border-radius: 0.5rem;
    transform: none;
  }
  && a:hover {
    color: #2789fd;
    background-color: rgba(39, 137, 253, 0.08);
    transform: none;
  }
`;
